<span class="call-controls-item-wrapper volume popout popup-wrapper horizontal">
  <button
    title="Change Volume"
    class="call-controls-item audio__no-hide"
    tabindex="0"
    data-mousedown="false"
    (click)="volumeMute()"
  >
    <img
      id="volume-slider-mute-icon"
      class="audio__no-hide call-controls-img"
      alt="Mute"
      [src]="
        volumeBar >= 75
          ? 'resources/img/instacall/volume_loud.png'
          : volumeBar > 0
          ? 'resources/img/instacall/volume_low.png'
          : 'resources/img/instacall/volume_none.png'
      "
    />
  </button>
  <div id="volume-slider-wrapper">
    <img id="volume-slider-icon" alt="Loud" [src]="'resources/img/volume/loud.png'" />
    <input
      type="range"
      id="volume-slider"
      name="volume-slider"
      step="1"
      min="0"
      max="100"
      class="volume-slider-horizontal"
      [(ngModel)]="volumeBar"
      (keypress)="onKeyPress($event)"
      (click)="onClick($event)"
      (focus)="setHoverBackground(true)"
      (blur)="setHoverBackground(false)"
      (mouseover)="setHoverBackground(true)"
      (mouseleave)="setHoverBackground(false)"
      [ngStyle]="{ 'background-image': volumeSliderBackground }"
    />
  </div>
</span>

<!-- class="call-controls-item-wrapper volume popout popup-wrapper" -->
